import React from 'react';
import { ModalUrl } from 'hooks/useModal';
import useQueryParams from 'hooks/useQueryParams';
import Link from 'next/link';

interface Props {
  children: React.ReactNode;
  modal: ModalUrl;
  params: Record<string, string>;
}

const ModalLink = ({ children, modal, params }: Props) => {
  const { buildModalParams } = useQueryParams();

  return (
    <Link
      href={buildModalParams(modal, params)}
      shallow
      passHref
      replace
      prefetch={false}
      scroll={false}
    >
      {children}
    </Link>
  );
};

export default ModalLink;
